import {
  AfterViewInit,
  Directive,
  ElementRef,
  inject,
  input,
  output,
} from '@angular/core';
import { debounceTime, fromEvent } from 'rxjs';

@Directive({
  selector: '[libDebounceTime]',
})
export class DebounceTime implements AfterViewInit {
  debounceTime = input(1000);

  elementRef = inject(ElementRef);

  ngAfterViewInit(): void {
    fromEvent(this.elementRef.nativeElement, 'keyup')
      .pipe(debounceTime(this.debounceTime()))
      .subscribe(() => {
        this.searchValue.emit(this.elementRef.nativeElement.value);
      });
  }
  searchValue = output<string>();
}
